export default __webpack_public_path__ + "media/images/icons/linkedin-f40410445e859153f9822ead79adc02e.svg";